import React, { useState, useEffect } from 'react'
import {useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import { Col, Container, Form, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";

const TopBar = () => {
    const  { auth } = useAuth();
    const navigate = useNavigate();
        const logout = useLogout(); 
    
        const signOut = async () => {
            await logout();
            navigate('/login');
        }

        const [time, setTime] = useState(new Date().toLocaleTimeString());

        useEffect(() => {
          const interval = setInterval(() => {
            setTime(new Date().toLocaleTimeString());
          }, 1000);
      
          return () => clearInterval(interval); // Cleanup on unmount
        }, []);
  return (
    <>
        <Container>
        {/* <div className="dashhead">
                        <Row>
                            <Col>
                            <img src="/images/name.png" width="20%" className='navimg'/>
                            </Col>
                            <Col>
                            <div className="dashdiv">
                            <strong><i className="bx bxs-user icon dashicon"></i></strong> {auth?.name} / 
                            
                            <Link onClick={signOut} className="dashsign"><strong> <i className="bx bx-log-out icon dashiconr"></i></strong>  Sign Out</Link> 
                            </div>
                            </Col>
                        </Row>
                    </div> */}

                    <div className="dashheads">
                        <Row>
                            <Col>
                            <i className="bx bxs-time icon dashiconnewt"></i><span className='spannew'> {time} </span> 
                            </Col>
                            <Col>
                            <div className="dashdiv">
                            <strong><i className="bx bxs-user icon dashiconnewt"></i></strong><span className='spannew'> {auth?.name} </span>  
                            
                            {/* <Link onClick={signOut} className="dashsign"><strong> <i className="bx bx-log-out icon dashiconr"></i></strong>  Sign Out</Link>  */}
                            </div>
                            </Col>
                        </Row>
                    </div>
        </Container>
    </>
  )
}

export default TopBar